<app-stats-overlay *transloco="let t">
  <div class="flex flex-col gap-4">
    <grid-layout>
      <div class="flex w-full flex-col gap-4">
        <div class="font-medium">
          {{ t("catalog-page.managed_products") }}
          <IBadge [label]="managedCatalogGridData.length.toString()" color="gray" class="ml-1" />
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            @if (selectedManagedProducts.length > 0) {
              <IButton
                [disabled]="isReadOnly"
                tooltipValue="{{ t('catalog-page.stop_managing_product', { count: selectedManagedProducts.length }) }}"
                (onClick)="stopManagingProducts()"
                color="red"
                icon="icon-[lucide--package-minus]"
                label="{{ t('catalog-page.stop_managing_button') }}"
              />
              <IButton
                [disabled]="isReadOnly"
                tooltipValue="{{ t('catalog-page.edit_custom_field_tooltip') }}"
                label="{{
                  t('catalog-page.edit_custom_field_button', {
                    name: inventoryConfig?.customField1Name ?? '1',
                    number: 1,
                  })
                }}"
                icon="icon-[mdi--playlist-edit]"
                color="white"
                (onClick)="groupEditCustomField('field1')"
              />
              <IButton
                [disabled]="isReadOnly"
                tooltipValue="{{ t('catalog-page.edit_custom_field_tooltip') }}"
                label="{{
                  t('catalog-page.edit_custom_field_button', {
                    name: inventoryConfig?.customField2Name ?? '2',
                    number: 2,
                  })
                }}"
                icon="icon-[mdi--playlist-edit]"
                color="white"
                (onClick)="groupEditCustomField('field2')"
              />
            }
          </div>

          <div class="flex items-center gap-2">
            <IButton (onClick)="resetColumns()" color="white" size="sm" label="{{ t('common.restore_columns') }}" />
            @if (accountMarketplace && accountMarketplace.accountType !== "SELLER") {
              <IButton
                [icon]="ICON_ADD"
                label="{{ t('common.add_asins') }}"
                to="/product-center/catalog/upload"
                queryParamsHandling="merge"
              />
            }
            <IButton
              [disabled]="isReadOnly"
              tooltipValue="{{ t('catalog-page.update_custom_field_names') }}"
              [icon]="ICON_GEAR"
              (onClick)="openCustomFieldsSettings()"
              color="white"
              label="{{ t('catalog-page.custom_field_settings') }}"
            ></IButton>
            <IButton
              [disabled]="isReadOnly"
              [label]="t('common.import')"
              [tooltipValue]="t('catalog-page.upload_catalog_data')"
              [icon]="ICON_IMPORT"
              (onClick)="uploadCatalogData()"
              color="white"
            />
            <IDropdown [items]="exportManagedMenuItems" placement="bottom-end">
              <IButton
                [disabled]="isReadOnly"
                [label]="t('common.export')"
                tooltipValue="{{ t('common.export_as_csv') }}"
                [icon]="ICON_EXPORT"
                color="white"
              />
            </IDropdown>
          </div>
        </div>
        <ag-grid-angular
          class="h-[40rem] w-full"
          #grid
          [rowData]="managedCatalogGridData"
          [gridOptions]="gridOptions"
          [animateRows]="true"
          (gridReady)="onGridReady($event)"
        />
      </div>
    </grid-layout>
    <grid-layout>
      <div class="flex w-full flex-col">
        <div class="flex items-center gap-2">
          <IButton
            icon="icon-[lucide--chevron-right]"
            size="sm"
            variant="ghost"
            [class.rotate-90]="unmanagedCatalogSection"
            (onClick)="toggleUnmanagedCatalogSection()"
          />
          <div class="font-medium">
            {{ t("catalog-page.unmanaged_products") }}
            <IBadge [label]="unmanagedCatalogGridData.length.toString()" color="gray" class="ml-1" />
          </div>
        </div>

        <IAccordion [isOpen]="unmanagedCatalogSection">
          <div class="my-4 flex items-center justify-between">
            <div class="flex items-center gap-2">
              @if (selectedUnmanagedProducts.length > 0) {
                <IButton
                  [disabled]="disableRestoreButton()"
                  [matTooltip]="getTooltipForRestoreButton()"
                  (onClick)="restoreToManagedProducts()"
                  icon="icon-[lucide--package-plus]"
                  label="{{ t('catalog-page.restore_managed_products') }}"
                />
              }
            </div>

            <div class="flex items-center gap-2">
              <IDropdown [items]="bulkManageCatalogModeItems" placement="bottom-end">
                <IButton
                  [disabled]="isReadOnly"
                  tooltipValue="{{ t('common.import') }}"
                  [icon]="ICON_IMPORT"
                  color="white"
                  label="{{ t('common.import') }}"
                />
              </IDropdown>

              <IDropdown [items]="[catalogManagementModeItems()]" placement="bottom-end">
                <IButton
                  [icon]="
                    catalogManagementMode() === 'auto'
                      ? 'icon-[material-symbols--play-circle-rounded]'
                      : 'icon-[material-symbols--pause-circle-rounded]'
                  "
                  [label]="catalogManagementMode() === 'auto' ? t('common.auto') : t('common.custom')"
                  [color]="catalogManagementMode() === 'auto' ? 'main' : 'white'"
                />
              </IDropdown>
            </div>
          </div>
          <ag-grid-angular
            class="h-[40rem] w-full"
            #unmanagedGrid
            [rowData]="unmanagedCatalogGridData"
            [gridOptions]="unmanagedGridOptions"
            [animateRows]="true"
          />
        </IAccordion>
      </div>
    </grid-layout>
  </div>
</app-stats-overlay>
